module.exports = __webpack_public_path__ + "static/media/smile.a2db575a.png";